import { Nationality } from '../../dto/SearchTagDto';

export const NATIONALITY_OPTIONS: Nationality[] = ['Brasileiro', 'Estrangeiro'];

export function normalizeNationality(raw: unknown): Nationality | null {
	if (typeof raw !== 'string') return null;
	const v = raw.trim().toLowerCase();
	if (!v) return null;

	if (['brasileiro', 'brasileira', 'br', 'bra', 'brasil'].includes(v)) {
		return 'Brasileiro';
	}
	if (
		['estrangeiro', 'estrangeira', 'ext', 'foreign', 'exterior'].includes(v)
	) {
		return 'Estrangeiro';
	}
	return null;
}
